/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteProductMutationResponse,
  DeleteProductPathParams,
} from "../types/DeleteProduct.ts"

export const deleteProductMutationKey = () =>
  [{ url: "/v1/product/delete-single-product/:productId" }] as const

export type DeleteProductMutationKey = ReturnType<
  typeof deleteProductMutationKey
>

/**
 * @summary Delete a product
 * {@link /v1/product/delete-single-product/:productId}
 */
export async function deleteProduct(
  productId: DeleteProductPathParams["productId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteProductMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "DELETE",
    url: `/v1/product/delete-single-product/${productId}`,
    ...requestConfig,
  })
  return res
}

export function deleteProductMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = deleteProductMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteProductMutationResponse>,
    ResponseErrorConfig<Error>,
    { productId: DeleteProductPathParams["productId"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ productId }) => {
      return deleteProduct(productId, config)
    },
  })
}

/**
 * @summary Delete a product
 * {@link /v1/product/delete-single-product/:productId}
 */
export function useDeleteProduct<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteProductMutationResponse>,
      ResponseErrorConfig<Error>,
      { productId: DeleteProductPathParams["productId"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteProductMutationKey()

  const baseOptions = deleteProductMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteProductMutationResponse>,
    ResponseErrorConfig<Error>,
    { productId: DeleteProductPathParams["productId"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteProductMutationResponse>,
    ResponseErrorConfig<Error>,
    { productId: DeleteProductPathParams["productId"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteProductMutationResponse>,
    ResponseErrorConfig<Error>,
    { productId: DeleteProductPathParams["productId"] },
    TContext
  >
}
